import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const StyledLink = styled.div(() =>
  mq({
    display: 'flex',
    width: '100%',
    padding: [
      `${defaultTheme.spacing.l} 0`,
      `${defaultTheme.spacing.l} 0`,
      `${defaultTheme.spacing.xxl} 0`,
      `${defaultTheme.spacing.xxl} 0`,
    ],
    '& > div:first-of-type': {
      marginRight: defaultTheme.spacing.l,
    },
  }),
);

export const Thumbnail = styled.div(() =>
  mq({
    borderRadius: defaultTheme.border.radius.xs,
    overflow: 'hidden',
    flex: '0 0 auto',
    width: ['144px', '144px', '192px', '192px'],
    height: ['45px', '45px', '60px', '60px'],
  }),
);
